<ng-content select="[tiimeTimelineItemDate]"></ng-content>
<div class="tiime-timeline-item-gutter">
  @if (color()) {
    <div [class]="'event--color ' + color()"></div>
  }
  <div class="tiime-timeline-item-line"></div>
</div>
<div class="event--infos">
  <ng-content select="[tiimeTimelineItemTitle]"></ng-content>
  <ng-content select="[tiimeTimelineItemDescription]"></ng-content>
</div>
